// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 班级管理
import Goods from '@/views/goods/classInfo';
// 班级管理
import ClassInfo from '@/views/goods/classInfoByBzr';
// 科目管理
import SubjectTree from '@/views/goods/subjectTree';
// 学员管理
import Student from '@/views/goods/student/student';
// 课程表管理
import CourseTable from '@/views/goods/courseTableManage'
// 签到情况
import SignInStatus from '@/views/goods/signInStatus'
// 学习卡管理
import LearningCard from '@/views/goods/learningCardManage'
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import reportChart from '@/views/report/reportChart';



/*
*  线下课程管理
* */
// 线下课程
import CourseManage from '@/views/course/courseManage';

/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Marketing from '@/views/system/marketing';
// 学员管理
import SysStudent from '@/views/system/student'
// 学习平台
import LearnPlat from '@/views/system/learnPlat'
// 教室管理
import Classroom from '@/views/system/classroom'
// 机构管理
import OrgManage from '@/views/system/orgManage'
// 课程表模板管理
import TemplateManage from '@/views/system/templateManage'
// 系统设置
import SysSetting from '@/views/system/sysSetting'

/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/report/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/goods/classInfo',
            name: '班组管理',
            component: Goods,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/goods/classInfoByBzr',
            name: '班组列表',
            component: ClassInfo,
            meta: {
                requireAuth: true
            }
        }, {
          path: '/goods/subjectTree',
          name: '科目管理',
          component: SubjectTree,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/goods/student',
          name: '学员管理',
          component: Student,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/goods/courseTableManage',
          name: '课程表管理',
          component: CourseTable,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/goods/signInStatus',
          name: '签到情况',
          component: SignInStatus,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/goods/learningCardManage',
          name: '学习卡管理',
          component: LearningCard,
          meta: {
            requireAuth: true
          }
        }, {
            path: '/machine/Machine',
            name: '机器信息管理',
            component: Machine,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineAisle',
            name: '货道信息管理',
            component: MachineAisle,
            meta: {
                requireAuth: true
            }
        },{
            path: '/course/courseManage',
            name: '线下课程',
            component: CourseManage,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/report/reportChart',
            name: '统计分析',
            component: reportChart,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/marketing',
            name: '营销渠道',
            component: Marketing,
            meta: {
                requireAuth: true
            }
        }, {
          path: '/system/learnPlat',
          name: '学习平台',
          component: LearnPlat,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/system/classroom',
          name: '教室管理',
          component: Classroom,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/system/templateManage',
          name: '课程表模板管理',
          component: TemplateManage,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/system/sysSetting',
          name: '系统设置',
          component: SysSetting,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/system/orgManage',
          name: '机构管理',
          component: OrgManage,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/system/student',
          name: '学员管理',
          component: SysStudent,
          meta: {
            requireAuth: true
          }
        }, {
            path: '/machine/MachineConfig',
            name: '支付配置信息',
            component: MachineConfig,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/report/Config',
            name: '支付配置',
            component: Config,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js